import { useEffect, useState, useContext } from "react";
import NAVBAR from "components/navbar";
import api from "services/api";
import AdminCampanhaModal from './modal';
import './style.css';
import { formatDate, getHoje } from "components/formatos";
import config from 'config';
import FOOTER from "components/footer";
import { CidadeContext } from "services/cidade";
import PAGINACAO from "components/paginacao";

function AdminCampanha() {
    const [lcampanha, setLCampanha] = useState([]);
    const [iesativa, setIesativa] = useState('S');

    // Modal
    const [operacao, setOperacao] = useState('');
    const [dados, setDados] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const { cod_cidade } = useContext(CidadeContext);

    function closeAdminCampanhaModal() {
        setIsOpen(false);
    }

    useEffect(() => {
        api.get(`${config.ADM_CAMPANHA}?cod_cidade=${cod_cidade}`)
            .then(response => {
                setLCampanha(response.data);
            });
    }, [isOpen, cod_cidade]);

    function novaCampanha() {
        setDados({
            'id_campanha': 0,
            'den_campanha': '',
            'validade_ini': getHoje(),
            'validade_fim': getHoje(),
            'banner': '',
            'cod_cidade': cod_cidade
        });
        setIsOpen(true);
    }

    function editarCampanha(linha) {
        api.get(`${config.ADM_CAMPANHA}/${linha.id_campanha}`)
            .then(response => {
                setOperacao('UPDATE');
                setDados(response.data[0]);
                setIsOpen(true);
            }).catch(err => {
                console.log(err);
            });
    }

    // Filtra campanhas ativas se iesativa === 'S'
    const hoje = getHoje();
    const campanhasFiltradas = iesativa === 'S'
        ? lcampanha.filter(c => new Date(c.validade_fim) >= new Date(hoje))
        : lcampanha;

    return (
        <div>
            <NAVBAR />
            <AdminCampanhaModal
                isOpen={isOpen}
                onRequestClose={closeAdminCampanhaModal}
                operacao={operacao}
                dados={dados}
            />
            <div className="mt-page">
                <h1>Campanhas</h1>
                <div style={{ marginBottom: 10 }}>
                    <label>
                        <input
                            type="checkbox"
                            checked={iesativa === 'S'}
                            onChange={e => setIesativa(e.target.checked ? 'S' : 'T')}
                        />{" "}
                        Somente ativas
                    </label>
                </div>
                <PAGINACAO
                    data={campanhasFiltradas}
                    itemsPerPage={20}
                    renderItems={(currentItems) => (
                        <table className="table table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th scope="col"># <button type="button" onClick={novaCampanha}>Nova</button></th>
                                    <th scope="col" className="d-none d-md-table-cell hidden-sm">Descrição</th>
                                    <th scope="col">Inicio</th>
                                    <th scope="col">Final</th>
                                    <th scope="col">operação</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentItems.map((e, index) => (
                                    <tr key={`vnd${index}`}>
                                        <th scope="row">{e.id_campanha}</th>
                                        <td className="d-none d-md-table-cell hidden-sm">{e.den_campanha}</td>
                                        <td>{formatDate(e.validade_ini)}</td>
                                        <td>{formatDate(e.validade_fim)}</td>
                                        <td>
                                            <button
                                                className='btn btn-warnning'
                                                type="button"
                                                onClick={() => editarCampanha(e)}
                                            >
                                                Editar
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                />
            </div>
            <FOOTER />
        </div>
    );
}

export default AdminCampanha;